import React, { useState, useEffect } from 'react';
import * as api from 'api';

// styles example: { loadingStyles: {...}, imageStyles: {...}
const ImageView = ({ filename, onPreview, ossKey, appId, styles = {} }) => {
	const [imageUrl, setImageUrl] = useState('');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		loadImage();
		return () => {
			if (imageUrl && imageUrl.startsWith('blob:')) {
				URL.revokeObjectURL(imageUrl);
			}
		};
	}, [filename, ossKey, appId]);

	const loadImage = async () => {
		if (!filename) {
			setLoading(false);
			return;
		}
		try {
			setLoading(true);
			const response = await api.downloadImage({ ossKey }, appId);
			console.log('下载图片响应:', response);
			const url = URL.createObjectURL(response);
			setImageUrl(url);
		} catch (error) {
			console.error('加载图片失败:', error);
			setImageUrl(
				'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik0zMCAyMEMzMy4zMTM3IDIwIDM2IDIyLjY4NjMgMzYgMjZWMzRDMzYgMzcuMzEzNyAzMy4zMTM3IDQwIDMwIDQwQzI2LjY4NjMgNDAgMjQgMzcuMzEzNyAyNCAzNFYyNkMyNCAyMi42ODYzIDI2LjY4NjMgMjAgMzAgMjBaIiBmaWxsPSIjQ0NDQ0NDIi8+CjxwYXRoIGQ9Ik0yMSAxOEMyMSAxNi4zNDMxIDI5IDE1IDMwIDE1QzMxIDE1IDM5IDE2LjM0MzEgMzkgMThWMjZDMzkgMjcuNjU2OSAzMSAyOSAzMCAyOUMyOSAyOSAyMSAyNy42NTY5IDIxIDI2VjE4WiIgZmlsbD0iIzk5OTk5OSIvPgo8L3N2Zz4K',
			);
		} finally {
			setLoading(false);
		}
	};
	const handleClick = () => {
		if (imageUrl && !loading && onPreview) {
			onPreview(imageUrl, filename);
		}
	};

	return (
		<div className="image-cell" style={{ cursor: imageUrl && !loading ? 'pointer' : 'default' }}>
			{loading ? (
				<div
					style={{
						width: 60,
						height: 60,
						backgroundColor: '#f0f0f0',
						borderRadius: 4,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						...(styles.loadingStyles ?? {}),
					}}
				>
					<span style={{ fontSize: 10, color: '#999' }}>Loading...</span>
				</div>
			) : (
				<img
					src={imageUrl}
					alt={filename}
					style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4, ...(styles.imageStyles ?? {}) }}
					onClick={handleClick}
					onError={(e) => {
						e.target.src =
							'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik0zMCAyMEMzMy4zMTM3IDIwIDM2IDIyLjY4NjMgMzYgMjZWMzRDMzYgMzcuMzEzNyAzMy4zMTM3IDQwIDMwIDQwQzI2LjY4NjMgNDAgMjQgMzcuMzEzNyAyNCAzNFYyNkMyNCAyMi42ODYzIDI2LjY4NjMgMjAgMzAgMjBaIiBmaWxsPSIjQ0NDQ0NDIi8+CjxwYXRoIGQ9Ik0yMSAxOEMyMSAxNi4zNDMxIDI5IDE1IDMwIDE1QzMxIDE1IDM5IDE2LjM0MzEgMzkgMThWMjZDMzkgMjcuNjU2OSAzMSAyOSAzMCAyOUMyOSAyOSAyMSAyNy42NTY5IDIxIDI2VjE4WiIgZmlsbD0iIzk5OTk5OSIvPgo8L3N2Zz4K';
					}}
				/>
			)}
		</div>
	);
};

export default ImageView;
